export default __webpack_public_path__ + "css/CustomerSalesOrderIndex.bundle.css";